import { getEditContactPageUrl } from 'modules/contacts/utils/get-edit-contact-page-url'
import { EmailStatistics } from 'modules/mailing/email-statistics/types/email-statistics-interface'
import Link from 'next/link'
import React from 'react'
import { StatusCell } from 'shared/components/table/cells/status-cell'
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { UserInterface } from 'shared/types/user-interface'
import { dateTimeFormat } from 'shared/utils/date-time-format'

export const emailStatisticsTableColumns = ({
  disableEmailLink,
  user,
  t,
}: {
  disableEmailLink?: boolean
  user?: UserInterface
  t: TLocoType
}): ColumnDefinitionInterface<EmailStatistics>[] => [
  {
    key: 'SENT AT',
    header: t('dashboard.email_statistics.table.headers.sent_at'),
    widthPercent: 15,
    onRender: statistics =>
      dateTimeFormat(statistics.createdAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone,
      }),
  },
  {
    key: 'EMAIL',
    header: t('dashboard.email_statistics.table.headers.email'),
    widthPercent: 20,
    onRender: statistics => {
      if (statistics.contact) {
        return (
          <div className="truncate">
            {statistics.contact.removedAt || disableEmailLink ? (
              <span className={'w-full'}>{statistics.contact.email}</span>
            ) : (
              <Link
                href={getEditContactPageUrl(statistics.contact.id)}
                className="primary-link w-full"
              >
                {statistics.contact.email}
              </Link>
            )}
          </div>
        )
      }
      return <span>{t('global.hidden')}</span>
    },
  },
  {
    key: 'OPENED',
    header: t('dashboard.email_statistics.table.headers.opened'),
    widthPercent: 10,
    onRender: statistics => <StatusCell isActive={!!statistics.openedAt} />,
  },
  {
    key: 'CLICKED',
    header: t('dashboard.email_statistics.table.headers.clicked'),
    widthPercent: 10,
    onRender: statistics => <StatusCell isActive={!!statistics.clicked} />,
  },
  {
    key: 'REPORTED AS SPAM',
    header: t('dashboard.email_statistics.table.headers.reported_as_spam'),
    widthPercent: 10,
    onRender: statistics => <StatusCell isActive={!!statistics.spam} />,
  },
  {
    key: 'BOUNCED',
    header: t('dashboard.email_statistics.table.headers.bounced'),
    widthPercent: 10,
    onRender: statistics => <StatusCell isActive={!!statistics.bounced} />,
  },
]
